<template>
  <div>
    <v-tabs
      v-if="filterItems && filterItems.length && !noTabs"
      v-model="currentFilter"
      show-arrows
      grow
      small
      dark
      class="mb-2"
    >
      <v-tab
        key="all_tabs"
        v-if="!hideAllTabFilter"
        style="background-color: grey"
      >
        All
      </v-tab>
      <v-tab
        v-for="item in filterItems"
        :style="{ 'background-color': item.color || 'black' }"
        :key="item.caption"
      >
        {{ item.caption }}
      </v-tab>
    </v-tabs>
    <v-toolbar flat class="pt-3">
      <v-combo
        class="ml-2"
        v-model="curForeman"
        v-bind="foremanCombo"
      ></v-combo>
    </v-toolbar>

    <v-cal-tbl-map
      :reload="reload"
      :eventClick="eventClick"
      :eventTemplate="eventTemplate"
      :getItemColor="getItemColor"
      :coloredFields="['foreman', 'status', 'warehouse', 'agent']"
      :tableKey="tableKey"
      :onDataReceived="onDataReceived"
      :activeTab="activeTab"
      :noDelete="true"
      ref="calTblMap"
      :linkClick="linkClick"
      :link="link"
      :mapTitle="mapTitle"
      :tableName="tableName"
      :mapReady="mapReady"
      :mapData="mapData"
      :mapLegend="mapLegend"
      :editable="editable"
      :onMarkerClick="onMarkerClick"
      :showGroupBy="true"
      :dateField="dateField"
      :getDataObject="getDataObject"
      :defaultEventColor="defaultEventColor"
      :updateTable="updateTable"
      :isDraggable="tableDraggable"
      :objKey="objKey"
      :mapLoading="mapLoading"
      :onLegendSelection="onLegendSelection"
      :filterItems="filterItems"
      calHeight="65vh"
    >
    </v-cal-tbl-map>
  </div>
</template>

<script>
import * as fun from "../plugins/common";
import axios from "axios";
import { resolve } from "path";
import { it } from "vuetify/lib/locale";
export default {
  name: "LDDispatch",
  components: {
    VCombo: () => import("../components/ComboBox.vue"),
    VCalTblMap: () => import("../components/CalTblMap.vue"),
  },
  props: {},
  data() {
    return {
      objKey: 0,
      mapTitle: "Pickup Map",
      tableName: "lddispatch",
      curForeman: {},
      defaultEventColor: "#137C15FF",
      data_object: null,
      // activeTab: 0,
      dateField: "date",
      link: {
        field: "shipment_id",
        name: "shipment",
      },
      mapData: [],
      dataTable: [],
      mapLegend: {
        data_object: {
          object_name: "v_foreman",
          get_table: "all",
        },
        getFreshData: true,
        mobileBreakpoint: 0,
        foreman: [],
        status: [],
        agent: [],
        all_records: true,
        table_title: "Foreman",
        tableName: "foreman",
        hasSearch: true,
        fields_included: ["employee_id", "full_name", "agent"],
        noTabs: true,
        hideHeader: true,
        singleSelect: true,
        coloredFields: ["employee_id", "agent"],
        getItemColor: function(e, slot, item, tableName) {
          return item.color;
        },
        width: 4,
      },
      editable: ["foreman"],
      foremanCombo: {
        label: "Foreman",
        objName: "v_foreman",
        itemText: "full_name",
        itemValue: "_id",
        defaultIndex: -1,
        returnObject: true,
      },
      tableDraggable: true,
      currentDate: null,
      filterItems: [],
      currentFilter: "",
    };
  },
  mounted() {
    var that = this;
    this.$root.$on("tableItemChanged", (t) => {
      if (!t.tbl.tableName && !t.tbl.objectName) {
        return;
      }
      var curRec = that.dataTable.filter((r) => {
        return r._id == t.item._id;
      })[0];
    });
    // this.$root.$on("tableSelectionChanged", (t) => {
    //   // console.log(t);
    //   if (t.tableName == "foreman") {
    //     var rec = t.selected[0];
    //   }
    // });
  },
  beforeDestroy() {},
  methods: {
    onLegendSelection(selected, map) {
      console.log(selected, map);
      // switch (this.dispatchType) {
      //   case "ld-pickup":
      var innerElement = document.getElementsByClassName("map-inner"),
        len = innerElement !== null ? innerElement.length : 0,
        i = 0;
      // innerElement[0].classList.remove("highlighted");
      for (i; i < len; i++) {
        // innerElement[i].className = "map-inner";
        innerElement[i].classList.remove("highlighted");
      }
      if (selected.length) {
        var className = selected[0].employee_id;

        if (className) {
          var highlighted = document.getElementsByClassName(
            className.replace(" ", "-")
          );
          len = highlighted !== null ? highlighted.length : 0;
          i = 0;
          // innerElement[0].classList.add("highlighted");
          for (i; i < len; i++) {
            highlighted[i].classList.add("highlighted");
          }
        }
      }
    },
    updateTable(t, f) {
      var that = this;
      var data = [];
      data.push({
        collection: "shipment",
        // id_fields: ["estimate.non-binding.shipment_service.itinerary._id"],
        qry: {
          _id: t.item._id,
          "estimate.non-binding.shipment_service.itinerary": {
            $elemMatch: { _id: t.item.itinerary_id },
          },
        },
        update: {
          "estimate.non-binding.shipment_service.$[s].itinerary.$[i].foreman":
            t.item.foreman,
          // "estimate.non-binding.shipment_service.$[s].itinerary.$[i].etd":
          //   t.item.etd,
          // "estimate.non-binding.shipment_service.$[s].itinerary.$[i].agent":
          //   t.item.agent,
        },
        array_filters: [
          {
            "s._id": t.item.service_id,
          },
          {
            "i._id": t.item.itinerary_id,
          },
        ],
        no_id: ["i", "estimate.non-binding.shipment_service.itinerary"],
      });

      axios
        .post(this.serverURL + "/modify_value", data, {
          withCredentials: true,
        })
        .then((r) => {
          this.$refs.calTblMap.calKey = !this.$refs.calTblMap.calKey;
          this.$root.$emit("mapDataChanged", {
            data: this.mapData,
            legend: this.mapLegend,
            updateLegend: true,
          });
        });
    },
    linkClick: function(item) {
      this.$root.addResentTab(item);
    },

    getItemColor(e, slot, item, tableName) {
      var color = "black";
      switch (slot) {
        case "status":
          if (e) {
            try {
              color = this.status.filter((f) => {
                return f.status == e;
              })[0].color;
            } catch (error) {
              console.log(error);
            }
          }
          break;
        case "foreman":
          if (e) {
            try {
              color = this.foreman.filter((f) => {
                return f._id == e._id;
              })[0].color;
            } catch (error) {
              // console.log(error);
            }
          }

          break;
        case "warehouse":
          if (e) {
            try {
              color = this.warehouse.filter((f) => {
                return f._id == e._id;
              })[0].color;
            } catch (error) {
              // console.log(error);
            }
          }

          break;
        case "agent":
          if (e) {
            try {
              color = this.agent.filter((f) => {
                return f._id == e._id;
              })[0].color;
            } catch (error) {
              // console.log(error);
            }
          }

          break;
        default:
          break;
      }
      return color;
    },
    eventTemplate: function(e, data, obj) {
      var parent = fun.getParentByProperty(obj, "getLocation");
      // if (e.agent) {
      //   var agent = this.agent.filter((a) => {
      //     return a._id == e.agent._id;
      //   });
      //   if (agent.length) {
      //     e.color = agent[0].color;
      //   }
      // }
      e.color = "grey";
      if (e.foreman) {
        var foreman = this.foreman.filter((a) => {
          return a._id == e.foreman._id;
        });
        if (foreman.length) {
          e.color = foreman[0].color;
        }
      }

      var eventColor = e.color;
      if (e.pickup && e.pickup.address) {
        var address = "",
          ev,
          serviceDate;

        try {
          e.orig_city = e.pickup.address.city;
          e.orig_state = e.pickup.address.stateCode;
          address = e.orig_city + ", " + e.orig_state;
          e.first_name = e.customer.first_name;
          e.last_name = e.customer.last_name;

          e.dest_city = e.dropoff.address.city;
          e.dest_state = e.dropoff.address.stateCode;
          address = e.dest_city + ", " + e.dest_state;
        } catch (error) {
          //
        }
      }
      parent = fun.getParentByProperty(obj, "eventType");

      serviceDate = new Date(e.service_date);

      var endTime = serviceDate.addHours(1);
      var frm = e.foreman ? " frm: " + e.foreman.full_name : "";
      ev = {
        name: e.shipment_id + " " + address + frm,
        start: serviceDate,
        shipment_id: e.shipment_id,
        first_name: fun.getObjectByKey(e, "first_name"),
        last_name: fun.getObjectByKey(e, "last_name"),
        agent_id: e.agent_id,
        itinerary: e.itinerary,
        color: eventColor,
        // end: fun.formatDateTime(endTime),
        timed: false,
      };

      return ev;
    },

    getDataObject(tbl) {
      var data_object = {
        object_name: "v_foremen_schedule",
        schema_name: "foreman_dispatch",
        qry: { date: { $ne: null } },
        date_fields: ["date"],
        mobileBreakpoint: 0,
        id_fields: ["agent_id"],
        fields_excluded: ["route"],
        get_table: "all",
        additional_data: [
          { obj_name: "service_type" },
          { obj_name: "itinerary_status" },
          { obj_name: "warehouse" },
          { obj_name: "agent" },
          { obj_name: "v_foreman" },
        ],
        aggregate_variables: {},
        item_key: "shipment_id",
        table_title: "Shipments",
        hasSearch: true,
        // add_function: "update_customer_geo",
      };
      var foremanQry =
        this.curForeman && this.curForeman._id
          ? { "foreman._id": this.curForeman._id }
          : {};
      var agentQry = this.currentFilter
        ? { "agent._id": this.agent[this.currentFilter - 1]._id }
        : {};
      var qry = { $and: [foremanQry, agentQry] };
      data_object.qry = qry;
      return data_object;
    },

    onMarkerClick(data, e) {
      var topElement = e.target
        .closest(".map-outer")
        .getElementsByClassName("map-top")[0];
      var innerElement = e.target
        .closest(".map-outer")
        .getElementsByClassName("map-inner")[0];

      var unassign = false;
      var msg = "";

      if (
        data.legend.selected[0] &&
        topElement.innerHTML == data.legend.selected[0].employee_id
      ) {
        unassign = true;
      }
      msg =
        "Confirm assigning " +
        data.legend.selected[0].full_name +
        " to #" +
        data.shipment_id +
        "?";

      if (unassign) {
        msg = "Confirm unassigning #" + data.shipment_id + "?";
      }

      data.foreman = {
        _id: data.legend.selected[0]._id,
        full_name: data.legend.selected[0].full_name,
      };
      this.dataTable.filter((r) => {
        return r._id == data._id;
      })[0].foreman = data.foreman;
      this.updateTable({ item: data }, (resp) => {
        if (data.foreman) {
          this.updateForemanOnMap(data, topElement);
        }
      });
    },
    updateForemanOnMap(data, topElement) {
      var curForeman = this.foreman.filter((f) => {
        return f._id == data.foreman._id;
      });
      if (curForeman[0]) {
        topElement.innerHTML = curForeman[0].employee_id;
        topElement.style.backgroundColor = curForeman[0].color;
        topElement.style.display = "block";
      }
    },
    eventClick(e) {
      this.linkClick(e.event);
    },
    getLocation(r, stopType) {
      try {
        var stops = r.stops;
        var st = stops.filter((s) => {
          return s.value == stopType;
        })[0];
        if (st) {
          var location = r.customer.address.filter((a) => {
            return a.full_address == st.full_address;
          })[0];
          if (location && location.location.address.geo) {
            location = location.location.address.geo;
          }
          return location;
        }
      } catch (error) {
        //
      }
    },
    createMapData(r) {
      var markerColor = "green";
      var agent = this.agent.filter((a) => {
        return a._id == r.agent._id;
      })[0];
      if (agent) {
        markerColor = agent.color;
      }

      if (r.pickup) {
        var topElementValue = "";
        var topElementColor = "";
        var orig = r.pickup;
        var path = ["location", "address", "geo", "location", "position"];
        var pos = orig.position;
        if (pos && parseFloat(pos[0]) && parseFloat(pos[1])) {
          var label =
            r.customer.first_name +
            " " +
            r.customer.last_name +
            " #" +
            r.shipment_id;
          if (r.delivery_date_range) {
            label += "<br>Delivery Dates:<br>" + r.delivery_date_range;
          }
          var time = fun.formatTime(r.date, true);
          //           shortLabel: '<div class="mdi mdi-forklift"></div>'

          var shortLabel =
            r.step == "w2w" || r.step == "w2d"
              ? '<div class="mdi mdi-forklift"></div>'
              : time;
          if (r.foreman) {
            var curForeman = this.foreman.filter((f) => {
              return f._id == r.foreman._id;
            });
            if (curForeman[0]) {
              topElementValue = curForeman[0].employee_id;
              topElementColor = curForeman[0].color;
            }
          }

          // var markerColor = whs && whs[0] ? whs[0].color : "green";

          var color = "white";

          this.mapData.push({
            pos: {
              lat: pos[0],
              lng: pos[1],
            },
            // whs: r.warehouse,
            label: label,
            address: orig.address.label,
            shortLabel: shortLabel,
            markerColor: markerColor,
            color: color,
            shipment_id: r.shipment_id,
            service_id: r.service_id,
            itinerary_id: r.itinerary_id,
            first_name: r.customer.first_name,
            last_name: r.customer.last_name,
            topElementValue: topElementValue,
            topElementColor: topElementColor,
            _id: r._id,
          });
        }
        // }
      }
      // console.log(this.mapData);
    },
    onDataReceived(data, d) {
      // console.log(data);
      this.mapData = [];
      this.mapReady = false;
      this.foreman = data.additional_model.v_foreman;
      this.status = data.additional_model.itinerary_status;
      this.warehouse = data.additional_model.warehouse;
      this.agent = data.additional_model.agent;
      var v = this.curForeman;
      if (!d) {
        d = this.currendDate;
      } else {
        this.currendDate = d;
      }
      this.filterItems = [];
      this.agent.forEach((f) => {
        this.filterItems.push({
          name: "agent",
          value: f._id,
          caption: f.contact.company,
          color: f.color,
        });
      });

      if (d) {
        var serviceDate = fun.getFullDate(d);
        this.dataTable = data.model.filter((m) => {
          return fun.getFullDate(new Date(m.date)) == serviceDate;
        });
        // this.updateGeo((r) => {
        this.dataTable.forEach((r) => {
          this.createMapData(r);
        });
        // });
        // }
        this.$root.$emit("mapDataChanged", {
          data: this.mapData,
          legend: this.mapLegend,
        });
        this.mapReady = true;
        this.$refs.calTblMap.refreshTable();
        return this.dataTable;
        // } else {
        //   return this.dataTable;
      }
    },
    replaceColor(obj) {
      var classes = "";
      if (obj) {
        obj.forEach((s) => {
          try {
            if (s.color && s.color.replace) {
              if (s.color.length == 9 && s.color[0] == "#") {
                s.color = s.color.substr(0, 7);
              }
              var className = "color-" + s.color.replace("#", "");
              var classCss =
                "background-color:" + s.color + "; color:" + "white";
              // fun.invertColor(s.color);
              var cl = "\n." + className + " { " + classCss + "}";
              if (classes.indexOf(cl) == -1) {
                classes += cl;
              }
            }
          } catch (error) {
            console.log(error);
          }
        });
        this.$root.dynamicClasses(classes);
      }
    },
  },
  watch: {
    currentFilter() {
      this.getDataObject();
      if (this.$refs.calTblMap) {
        this.$refs.calTblMap.refresh();
      }
    },
    curForeman() {
      this.getDataObject();
      if (this.$refs.calTblMap) {
        this.$refs.calTblMap.refresh();
      }
    },
  },
};
</script>

<style lang="css" scoped></style>
